import { render, staticRenderFns } from "./AppTaskStepsItem.vue?vue&type=template&id=858e25ca&"
import script from "./AppTaskStepsItem.vue?vue&type=script&lang=js&"
export * from "./AppTaskStepsItem.vue?vue&type=script&lang=js&"
import style0 from "./AppTaskStepsItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports